import Alpine from "alpinejs";

Alpine.data("sortByFilter", (sortOptions) => ({
  open: false,
  sortOptions: sortOptions,
  init() {
    const currentSortBy = new URL(window.location.href).searchParams.get("sort_by");
    
    this.sortOptions = this.sortOptions.map((option) => ({ 
      value: option[0], 
      name: option[1], 
      active: option[0] === currentSortBy
    }));
  },
  getSortOptionUrl(sortOption) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('sort_by', sortOption.value);
    return currentUrl.toString();
  },
  get currentSortOptionName() {
    const activeOption = this.sortOptions.find(option => option.active);
    return activeOption ? activeOption.name : 'Sort By';
  }
}));
      